<template>
  <div class="v9-style-bottom" :class="{ mobile: isMobile ? true : false }" @click="handleClick">
    <div
      class="menu-box"
      v-if="!isMobile"
      :style="{
        height: $h_Ratio(menuStyle.height, $store) + 'px',
        minWidth: $w_Ratio(menuStyle.width, $store) + 'px',
      }"
      :class="{ 'menu-down': !isOpenBottomMenu }"
    >
      <div
        class="menu-list"
        :style="{
          top: $h_Ratio(-36, $store) + '%',
        }"
      >
        <div
          class="menu-item"
          :style="getMenuItemStyle()"
          @click="handleSwitchScene(item)"
          v-for="item in $store.state.ProjectInfo.SceneryList"
          :key="item.id"
        >
          <div
            class="menu-item-icon-ct"
            :class="{ active: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            <img :src="item.IconPath" alt="" class="img" />
          </div>
          <div
            class="menu-item-icon-name"
            :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }"
          >
            {{ item.SceneName }}
          </div>
        </div>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="mobile-menu" v-if="isMobile">
      <div class="icon" @click="isShow = !isShow">
        <img src="@/assets/img/mobile/menu.png" alt="" />
      </div>
      <div class="scene" :style="{ left: isShow ? '0%' : '150px' }">
        <div
          class="menu-item"
          :style="getMenuItemStyle()"
          @click="handleSwitchScene(item)"
          v-for="item in $store.state.ProjectInfo.SceneryList"
          :key="item.id"
        >
          <div
            class="menu-item-icon-ct"
            :class="{ active: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            <img src="/img/styles/menusIcons/bottomIcon/V3bottom.png" alt="" class="bk" />

            <img :src="item.IconPath" alt="" class="pic" />
          </div>
          <div
            class="menu-item-icon-name"
            :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }"
          >
            {{ item.SceneName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'V9StyleBottom',
  components: {},
  props: {
    Configuration: Object,
    SceneryList: Array,
  },
  data() {
    return {
      isShow: false,
      isOpenBottomMenu: true,
      style: {},
      menuStyle: {
        height: 85,
        width: 750,
      },
      menuItemStyle: {},
      backgroundDefault: null, // 临时存储原来背景
    };
  },
  watch: {
    SceneryList: {
      deep: true,
      handler: function (newVal) {
        this.setMenuShowLength(newVal);
      },
    },
  },
  created() {
    this.setMenuShowLength(this.SceneryList);
    if (this.Configuration.propertyData.menuStyle) {
      this.menuStyle = this.$_.cloneDeep(this.Configuration.propertyData.menuStyle.value);
    }
    this.backgroundDefault = this.$store.state.ProjectInfo.Background;
  },
  mounted() {
    this.SceneryList.sort((a, b) => {
      return a.sceneSortIndex - b.sceneSortIndex;
    });
  },
  methods: {
    ...mapMutations(['set_CurrentScene', 'set_ProjectBackground', 'set_CurrentConfigration']),
    setMenuShowLength(SceneryList) {
      if (SceneryList.length > 4) {
        this.menuStyle.width = 150 + (SceneryList.length - 4) * 95;
      }
      if (this.Configuration.propertyData.menuStyle) {
        this.$store.commit('set_ProjectStylePropertyData', {
          key: 'menuStyle',
          value: this.$_.cloneDeep(this.menuStyle),
        });
      }
    },
    toggleOpen() {
      this.isOpenBottomMenu = !this.isOpenBottomMenu;
    },
    handleSwitchScene(item) {
      this.set_CurrentScene(item.id);
      if (item.isChangeBk === true) {
        if (item.Background.componentTitle === '图片背景') {
          let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
          if (
            backgroundDefault == null ||
            backgroundDefault == 'null' ||
            backgroundDefault == undefined ||
            backgroundDefault == 'undefined'
          ) {
            this.set_ProjectBackground(this.backgroundDefault);
            this.set_CurrentConfigration(this.backgroundDefault);
          } else {
            this.set_ProjectBackground(backgroundDefault);
            this.set_CurrentConfigration(backgroundDefault);
          }
        } else {
          this.set_ProjectBackground(item.Background);
          this.set_CurrentConfigration(item.Background);
        }
      } else {
        let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
        if (
          backgroundDefault == null ||
          backgroundDefault == 'null' ||
          backgroundDefault == undefined ||
          backgroundDefault == 'undefined'
        ) {
          this.set_ProjectBackground(this.backgroundDefault);
          this.set_CurrentConfigration(this.backgroundDefault);
        } else {
          this.set_ProjectBackground(backgroundDefault);
          this.set_CurrentConfigration(backgroundDefault);
        }
      }
      // let name = this.$store.state.ProjectInfo.Background.componentName;
      // let map = {
      //   componentTitle: '地图背景',
      //   componentName: 'GisMapBackground',
      //   componentOverViewImg: './img/backgrounds/MapBackground.png',
      //   id: 'GisMapBackground',
      //   style: {
      //     backgroundColor: '#19242D',
      //   },
      //   propertyData: {
      //     mapBasicSetting: {
      //       value: {
      //         coordinate: {
      //           lng: '116.39156',
      //           lat: '39.90714',
      //         },
      //         zoom: 15,
      //         is3dMap: false,
      //       },
      //       propertyComponentName: 'mapBasicSetting',
      //       lable: '地图基本设置',
      //     },
      //     mapType: {
      //       value: {
      //         type: '2',
      //       },
      //       propertyComponentName: 'mapType',
      //       lable: '地图类型',
      //     },
      //     mapStyle: {
      //       value: {
      //         checkedId: 0,
      //         plan: {
      //           plancode: '575d2a1a8d57786ac4f8373f98808cef',
      //         },
      //       },
      //       propertyComponentName: 'mapStyle',
      //       lable: '个性化样式',
      //     },
      //   },
      //   mapPopupData: {
      //     propertyComponentName: 'MapPopup',
      //     value: {
      //       borderComponentName: 'point',
      //     },
      //   },
      // };
      // if (this.$store.state.ProjectInfo.CurrentScene?.isChangeBk) {
      //   if (name != 'GisMapBackground') {
      //     // 设置背景为地图
      //     this.set_ProjectBackground(map);
      //     this.set_CurrentConfigration(map);
      //   }
      // } else {
      //   if (name == 'GisMapBackground') {
      //     // 设置背景为原来保存的
      //     let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
      //     if (
      //       backgroundDefault == null ||
      //       backgroundDefault == 'null' ||
      //       backgroundDefault == undefined ||
      //       backgroundDefault == 'undefined'
      //     ) {
      //       this.set_ProjectBackground(this.backgroundDefault);
      //       this.set_CurrentConfigration(this.backgroundDefault);
      //     } else {
      //       this.set_ProjectBackground(backgroundDefault);
      //       this.set_CurrentConfigration(backgroundDefault);
      //     }
      //   }
      // }
    },
    getMenuStyle() {
      return {
        height: this.$h_Ratio(this.menuStyle.height, this.$store) + 'px',
        minWidth: this.$w_Ratio(this.menuStyle.width, this.$store) + 'px',
      };
    },
    getMenuItemStyle() {
      return {
        height: this.$w_Ratio(90, this.$store) + 'px',
        width: this.$w_Ratio(80, this.$store) + 'px',
        fontSize: '12px',
        margin: `0 ${this.$w_Ratio(15, this.$store)}px`,
      };
    },
    getToggleOpenBtn() {
      return {
        height: this.$h_Ratio(13, this.$store) + 'px',
        width: this.$w_Ratio(150, this.$store) + 'px',
        fontSize: this.$w_Ratio(14, this.$store) + 'px',
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      SceneryList: state => state.ProjectInfo.SceneryList,
    }),
    newSceneryList() {
      return this.SceneryList.sort((a, b) => {
        return a.sceneSortIndex - b.sceneSortIndex;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mobile {
  top: 20px;
  right: 0 !important;
  width: 40px !important;
  left: unset !important;
  transform: none !important;
  height: 40px;
}
.v9-style-bottom {
  z-index: 99;
  position: absolute;
  left: 30%;
  top: 7%;
  color: #05cede;
  .menu-box {
    position: absolute;
    bottom: 4px;
    width: 100%;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background-color: #c4c6c9;
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      background-color: #223e4d;
    }
    .bottom-bg {
      width: 100%;
      height: 90%;
      position: absolute;
      bottom: 0;
    }
    .menu-list {
      position: absolute;
      display: flex;
      top: -40%;
      // left: -2%;
      align-items: flex-end;
      justify-content: space-around;
      height: 100%;
      .menu-item {
        cursor: pointer;
        flex-shrink: 0;
        transition: all 0.3s ease-out;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        .menu-item-icon-name {
          text-align: center;
          white-space: nowrap;
          z-index: 5;
        }
        .menu-item-icon-ct {
          width: 100%;
          height: 100%;
          transition: all 0.3s ease-out;
          margin-bottom: 2px;
          position: relative;
          top: 0;
          img.img {
            position: absolute;
            z-index: 2;
            width: 100%;
            height: 50%;
            min-height: 30px;
            transition: all 0.3s ease-out;
            margin: 0 auto;
            top: 88%;
          }
          opacity: 0.8;
        }
        &:hover .menu-item-icon-ct {
          img.img {
            z-index: 2;
          }
        }
      }
    }
  }
  .menu-down {
    transform: translate(-50%, 200%);
  }
  .toggle-open-btn {
    cursor: pointer;
    width: 150px;
    height: 13px;
    font-size: 14px;
    background-color: #212631;
    border-radius: 20px 20px 0 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    font-weight: 700;

    &:hover {
      color: rgb(35, 130, 255);
    }
  }
}
.active {
  &:hover .menu-item-icon-ct {
    img.img {
      width: 100%;
      height: 60% !important;
    }
  }
  .menu-item-icon-name {
    color: #d9e7ec !important;
  }
  .menu-item-icon-ct {
    opacity: 1 !important;
    width: 110% !important;
    height: 80% !important;
    img.img {
      position: relative;
      min-height: 30px;
      width: 100% !important;
      height: 50% !important;
    }
  }
}
// 手机端
.mobile-menu {
  position: absolute;
  .icon {
    cursor: pointer;
    width: 30px;
  }
  .scene {
    position: absolute;
    left: -50px;
    top: 50px;
    background: url('../../../assets/img/mobile/style3/menu_item_bk.png') no-repeat;
    background-size: 100% 100%;
    transition: all 0.3s ease-in-out;
    transform: translate(-50%, 0);
    .menu-item {
      cursor: pointer;
      flex-shrink: 0;
      // background-color: #4a57ce;
      transition: all 0.3s ease-out;

      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;

      .menu-item-icon-name {
        text-align: center;
        z-index: 5;
        white-space: nowrap;
      }

      .menu-item-icon-ct {
        width: 70%;
        height: 46%;
        transition: all 0.3s ease-out;
        margin-bottom: 2px;
        position: relative;
        img.bk {
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 1;
        }
        img.pic {
          width: 100%;
          height: 100%;
          position: relative;
          z-index: 2;
          top: -10px;
        }

        opacity: 0.8;
      }

      .active {
        width: 90%;
        height: 58%;
        opacity: 1;
      }

      &:hover .menu-item-icon-ct {
        width: 90%;
        height: 58%;
      }
    }
  }
}
</style>
